import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import L from "leaflet";
import "leaflet-routing-machine";
import "leaflet/dist/leaflet.css";

function Otobus() {
  const [userLocation, setUserLocation] = useState(null);
  const [nearestStop, setNearestStop] = useState(null);
  const mapRef = useRef(null);

  // Duraklar (useMemo ile sabitlendi)
  const stops = useMemo(
    () => [
      { name: "Durak 1", lat: 37.8479, lng: 27.8456 },
      { name: "Durak 2", lat: 37.8500, lng: 27.8392 },
      { name: "Durak 3", lat: 37.8400, lng: 27.8510 },
    ],
    []
  );

  // Harita Başlatma
  useEffect(() => {
    if (mapRef.current) return;

    const map = L.map("map").setView([37.8479, 27.8456], 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "© OpenStreetMap contributors",
    }).addTo(map);

    stops.forEach((stop) => {
      L.marker([stop.lat, stop.lng]).addTo(map).bindPopup(stop.name);
    });

    mapRef.current = map;
  }, [stops]);

  // Kullanıcı konumu alma
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.watchPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = { lat: latitude, lng: longitude };
          setUserLocation(location);

          if (mapRef.current) {
            const userMarker = L.marker([latitude, longitude]).addTo(mapRef.current);
            userMarker.bindPopup("Şu an buradasınız").openPopup();
            mapRef.current.setView([latitude, longitude], 13);
          }
        },
        (error) => console.error("Konum alınamadı:", error),
        { enableHighAccuracy: true }
      );
    } else {
      console.error("Geolocation API desteklenmiyor.");
    }
  }, []);

  // Mesafe Hesaplama
  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // Dünya yarıçapı (km)
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLng = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Mesafe (km)
  };

  // En Yakın Durağı Hesaplama (useCallback ile sabitlendi)
  const calculateNearestStop = useCallback(
    (userLocation) => {
      let nearest = null;
      let shortestDistance = Infinity;

      stops.forEach((stop) => {
        const distance = calculateDistance(
          userLocation.lat,
          userLocation.lng,
          stop.lat,
          stop.lng
        );

        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearest = { ...stop, distance };
        }
      });

      setNearestStop(nearest);
    },
    [stops]
  );

  useEffect(() => {
    if (userLocation) {
      calculateNearestStop(userLocation);
    }
  }, [userLocation, calculateNearestStop]);

  const calculateArrivalTime = () => {
    if (!nearestStop) return null;
    const busSpeed = 40; // km/saat
    const timeInHours = nearestStop.distance / busSpeed;
    return Math.ceil(timeInHours * 60); // Dakika
  };

  return (
<div className="bg-sky-100 min-h-screen rounded shadow">
  <div className=" mx-auto py-8 px-4">
    <h1 className="text-2xl font-bold text-center text-blue-600 mb-6">
      Otobüs Haritası
    </h1>
    <div
      id="map"
      className="rounded-lg shadow-lg border border-gray-300"
      style={{ height: "500px", width: "100%", zIndex:2 }}
    ></div>
    {nearestStop && (
      <div className="bg-white rounded-lg shadow-lg p-6 mt-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          En Yakın Durak:
        </h2>
        <p className="text-lg text-gray-600 mb-2">
          <strong className="text-blue-500">{nearestStop.name}</strong> -{" "}
          <span className="font-semibold text-gray-800">
            {(nearestStop.distance * 1000).toFixed(2)} metre
          </span>
        </p>
        <p className="text-lg text-gray-600">
          Tahmini Süre:{" "}
          <span className="font-semibold text-green-500">
            {calculateArrivalTime()} dakika
          </span>
        </p>
      </div>
    )}
  </div>
</div>

  );
}

export default Otobus;
